import React from "react";
import "./HomePage.css";

const YourPrivacyChoices = () => (
  <div className="privacy-choices">
    <h4>Your Privacy Choices</h4>
    <p>
      At Give Stream, we respect your privacy and offer you the following
      choices regarding your personal information:
    </p>

    <h2>1. Access and Update Your Information</h2>
    <p>
      You have the right to access and update your personal information at any
      time. You can do this by logging into your account and updating your
      profile.
    </p>

    <h2>2. Opt-Out of Marketing Communications</h2>
    <p>
      You can opt-out of receiving marketing communications from us by following
      the unsubscribe instructions included in our emails or by contacting us
      directly.
    </p>

    <h2>3. Request Deletion of Your Information</h2>
    <p>
      You have the right to request the deletion of your personal information.
      Please contact us if you wish to exercise this right.
    </p>

    <h2>4. Object to Processing</h2>
    <p>
      You have the right to object to our processing of your personal
      information. Please contact us if you wish to exercise this right.
    </p>

    <h2>5. Data Portability</h2>
    <p>
      You have the right to request a copy of your personal information in a
      structured, commonly used, and machine-readable format. Please contact us
      if you wish to exercise this right.
    </p>

    <h2>6. Contact Us</h2>
    <p>
      If you have any questions about your privacy choices, please contact us at
      [info@givestream.com].
    </p>
  </div>
);

export default YourPrivacyChoices;
